<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>优惠券领取记录</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入优惠券名称/编号/服务商"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:title|string#or': searchValue,
                'fpi-regex:code|string#or': searchValue,
                'fpi-regex:orgName|string#or': searchValue,
                beanName: 'voucher',
                title: '优惠券领取记录列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields" :options="options">
            <template slot="typeIds">
              <el-table-column
                prop="typeIds"
                label="商品/商品类别"
                width="300px"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <template v-if="scope.row.type == '1'">
                    {{ osg.codelabelForArray('materials', scope.row.typeIds) }}
                  </template>
                  <template v-if="scope.row.type == '3'">
                    {{ osg.codelabelForArray('allClassify', scope.row.typeIds) }}
                  </template>
                </template>
              </el-table-column>
            </template>
            <template slot="presentId">
              <el-table-column prop="typeIds" label="赠送商品" width="300px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ osg.codelabel('presents', scope.row.presentId) }}
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    查看
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="优惠券信息" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="160px"
        :area="area"
        @changeForm="osg.changeForm"
        disabled
      >
        <template slot="typeIds">
          <el-select
            v-show="formData.type == 1"
            v-model="formData.typeIds"
            multiple
            filterable
            disabled
            placeholder="请选择适用商品"
          >
            <el-option
              v-for="(item, i) in options.materials"
              :key="i"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
          <el-cascader
            v-show="formData.type == 3"
            v-model="formData.typeIds"
            :options="options.classify"
            placeholder="请选择商品分类"
            filterable
            disabled
            :props="{
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              label: 'name',
              value: '_id',
              children: 'children'
            }"
          ></el-cascader>
        </template>
      </c-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'coupons',
  data() {
    window.$this = this;
    return {
      name: 'coupons',
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      extFields: [],
      extField: {},
      options: {
        materials: [],
        classify: [],
        allClassify: [],
        presents: []
      },
      rules: this.$util.rules,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        typeIds: [],
        exts: {}
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('voucher', () => {
      this.osg.getFpi();
      this.getData();
      this.getMaterials();
      this.getClassify();
      this.getAllClassify();
    });
  },
  methods: {
    getMaterials() {
      this.osg.ajax(
        'basic/material/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:rank|string#and': '1', // 平台上架的材料
          'ne:classifyId|string#and': '6239294986987325343',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.materials = res.data;
        }
      );
    },
    getClassify() {
      this.osg.ajax(
        '/biz/classify/queryClassify.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.options.classify = res.data;
        }
      );
    },
    getAllClassify() {
      this.osg.ajax('/biz/classify/queryWithSmooth.do', {}, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.allClassify = res.data;
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { typeIds: [], exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:title|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:orgName|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.setFpi(params);
      this.osg.ajax('biz/voucher/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      this.openDetail = true;
      // 解决插槽字段第一次不反显问题
      this.$nextTick(() => {
        this.formData = this.$util.deepCopy(row);
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax('biz/voucher/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('biz/voucher/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('biz/voucher/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('biz/voucher/remove.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    }
  }
};
</script>
